module.exports = __webpack_public_path__ + "img/tarjeta_ofertas_seguro_accidentes.ee63ba45.jpg";